export const LEAD_GENERATION_CONFIG = {
  // Timing constants
  SUCCESS_DISPLAY_DURATION: 3000,
  FORM_VALIDATION_DEBOUNCE: 300,
  
  // UI Constants
  MAX_COMPANY_NAME_LENGTH: 100,
  MAX_GEOGRAPHY_LENGTH: 50,
  
  // Validation patterns
  COMPANY_NAME_PATTERN: /^[a-zA-Z0-9\s\-&.,()]+$/,
  GEOGRAPHY_PATTERN: /^[a-zA-Z\s\-,]+$/,
} as const;

export const UI_THEME = {
  colors: {
    primary: '#0ea5e9',
    primaryHover: '#0284c7',
    primaryFocus: '#0ea5e9',
    
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    
    purple: {
      100: '#f3e8ff',
      200: '#e9d5ff', 
      300: '#d8b4fe',
      400: '#c084fc',
      500: '#a855f7',
      600: '#9333ea',
      700: '#7c3aed',
      800: '#6b21a8',
      900: '#581c87',
    },
    
    gray: {
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
    
    background: {
      primary: 'white',
      secondary: '#f9fafb',
      error: '#fef2f2',
      errorBorder: '#fecaca',
      gradient: 'linear-gradient(-45deg, #0ea5e9, #0369a1, #a855f7, #0ea5e9)',
    }
  },
  
  glassmorphism: {
    background: 'rgba(255, 255, 255, 0.15)',
    backgroundHover: 'rgba(255, 255, 255, 0.25)',
    backgroundFocus: 'rgba(255, 255, 255, 0.2)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderHover: '1px solid rgba(255, 255, 255, 0.3)',
    backdropFilter: 'blur(12px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  borderRadius: {
    sm: '8px',
    md: '12px',
  },
  
  fontSize: {
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '24px',
    xxl: '28px',
    xxxl: '48px',
  },
  
  fontWeight: {
    normal: '400',
    medium: '500',
    bold: 'bold',
  },
  
  shadows: {
    card: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    glass: '0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08)',
    glassSoft: '0 4px 16px rgba(0, 0, 0, 0.08)',
  },
  
  animations: {
    gradientMove: 'gradientMove 4s ease-in-out infinite',
    fadeIn: 'fadeIn 0.6s ease-out',
    slideUp: 'slideUp 0.5s ease-out',
    scaleIn: 'scaleIn 0.4s ease-out',
  }
} as const;

export const FORM_FIELD_CONFIG = {
  companyName: {
    id: 'company-name',
    label: 'Company Name',
    placeholder: 'e.g., Ericsson',
    required: true,
    maxLength: LEAD_GENERATION_CONFIG.MAX_COMPANY_NAME_LENGTH,
    pattern: LEAD_GENERATION_CONFIG.COMPANY_NAME_PATTERN,
  },
  geography: {
    id: 'geography',
    label: 'Geography',
    placeholder: 'e.g., Sweden, Stockholm, Europe',
    helpText: 'Specify the country, region, or city where the company operates',
    required: true,
    maxLength: LEAD_GENERATION_CONFIG.MAX_GEOGRAPHY_LENGTH,
    pattern: LEAD_GENERATION_CONFIG.GEOGRAPHY_PATTERN,
  }
} as const;